// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3ARsM","description":"PatientConsentPreview_description__33TD6"};